import React, { Component } from "react";
import "./style.css";
import "../../../../../../index.css";
class MajorQueryTip extends Component {
  render() {
    const { visible } = this.props;
    return (
      <div
        className={
          visible === true
            ? "majorQueryTip_box"
            : "majorQueryTip_box display_none"
        }
      >
        <img
          alt=""
          className="fl"
          src={require("../../../../../../images/powerful/majorquery/major_query_five_star.png")}
        ></img>
        <div className="fl majorQueryTip_box_text">
          查询专业对应的院校及选科要求
        </div>
      </div>
    );
  }
}

export default MajorQueryTip;



// WEBPACK FOOTER //
// ./src/containers/PowerfulQuery/components/MajorQuery/components/MajorQueryTip/index.js